export default __webpack_public_path__ + "static/media/service-thumb-paver-steps.dc0cd11a.jpg";